import { SET_TAB } from '../constants/actionTypes'

// Initialise the Cognito sesson from a callback href
export const setTab = tab => ({
  type: SET_TAB,
  tab
});
